import React from 'react';
import {Card,Button} from 'react-bootstrap'
import styled from 'styled-components'
import LongCard from './LongCard'
import LongCardInverted from './LongCardInverted'
import SmallCard from './SmallCard'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SmallCardContainer from './SmallCardContainer'

const StyledCol = styled(Col)`
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 20px;
    margin-left: 20px;
`

const CardContainer = ({refs}) => {
    return (
        <Container ref={refs} fluid style={{padding: '0', margin:'0'}}>
        <LongCard title='The Grounding of Music' writer='Sayan Ghosh' text='In the age of Spotify, SoundCloud, TikTok, etc., how much do local scenes matter in the development of a sound or new genre? Does this get rid of an intrinsic part of music culture or does it break down barriers and create new revolutionary methods of creative ideation?' image='https://www.michigandaily.com/sites/default/files/styles/large/public/200914/Untitled_Artwork.jpg?itok=3iSrlByX' link='https://www.michigandaily.com/section/bside/grounding-music'></LongCard>
        <SmallCardContainer></SmallCardContainer>
      </Container>
    );
}

export default CardContainer;